import logger, {ILogger} from "../logger";

import {Web3Store} from "./web3Store";
import {IAction, IGetActiveActionsResponse, IMythServerResponse} from "../bean/ResponseBean";

export class DataStore {

    account: string = '';

    private readonly _logger: ILogger
    private web3Store: Web3Store
    private allMenu: IAction[]
    private hasRequest = false;

    constructor(web3Store:Web3Store) {
        this._logger = logger
        this.web3Store = web3Store
        this.allMenu = []
    }
    /**
     * 从服务端获取所有活动
     */
    async getAllActions(): Promise<IMythServerResponse<IGetActiveActionsResponse> | undefined>  {
        try {
            if (this.web3Store.mythServerApi) {
                return this.web3Store.mythServerApi.getActiveActions();
            }
        } catch (ex: any) {
            logger.error(ex);
        }
    };
}
